import styled from "styled-components";
import { PagesEmployeeListUiInput } from "./Input";
import { PagesEmployeeListUiResults } from "./Results";
import type { employeeListAPIInterface } from "@dealer-center/ddc-pages-employee-list-interface";

const StyledPagesEmployeeListUi = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const StyledPageHeader = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1rem;
`;

interface PagesEmployeeListUiDisplayProps {
  setName: (name: string) => void;
  data?: employeeListAPIInterface;
  error?: string;
  loading: boolean;
  nameInput: string;
  setNameInput: (name: string) => void;
}

export const PagesEmployeeListUiDisplay = ({
  data,
  nameInput,
  setName,
  setNameInput,
  error,
  loading
}: PagesEmployeeListUiDisplayProps) => {
  return (
    <StyledPagesEmployeeListUi>
      <StyledPageHeader>Welcome to employeeList-react!</StyledPageHeader>
      <PagesEmployeeListUiInput
        loading={loading}
        nameInput={nameInput}
        setName={setName}
        setNameInput={setNameInput}
      />
      <PagesEmployeeListUiResults data={data} error={error} />
    </StyledPagesEmployeeListUi>
  );
};
